import formatDateTime from '@/filters/formatDateTime'

const filters = {
  formatDateTime
}

export default filters